export const PERSON_NODE_WIDTH = 160;
export const PERSON_NODE_HEIGHT = 160;
export const SPOUSE_CONNECTOR_WIDTH = 10;
export const SPOUSE_CONNECTOR_OVERLAP = 50;
export const EX_SPOUSE_CONNECTOR_WIDTH = 10;
export const EX_SPOUSE_CONNECTOR_OVERLAP = 45;
export const COUPLE_NODE_WIDTH = 2 * PERSON_NODE_WIDTH + SPOUSE_CONNECTOR_WIDTH;
export const EX_SPOUSE_WIDTH = 160;
export const COUPLE_NODE_HEIGHT = 160;
export const CONNECTOR_OFFSET = 28;
// Extend T-connectors slightly beyond handle center to ensure visual connection with edges
export const T_CONNECTOR_EDGE_OVERLAP = 4;

export const ELK_LAYER_SPACING = 70;
export const ELK_NODE_SPACING = 32;
export const ELK_EDGE_EDGE_SPACING = 2;
export const ELK_IN_LAYER_SPACING_FACTOR = 2.4;

// Enhanced edge-node spacing for simple layout to prevent edges from overlapping nodes
export const ENHANCED_EDGE_NODE_SPACING = 10;

// Optimized ELK options for family tree layouts with minimal interleaving and overlaps
export const SIMPLE_ELK_OPTIONS = {
  'elk.algorithm': 'layered',
  'elk.direction': 'DOWN',

  // Determinism - ensure consistent layouts across refreshes
  'elk.randomSeed': '42', // Fixed seed for reproducible layouts

  // Spacing options - control distances between nodes and edges
  'elk.layered.spacing.nodeNodeBetweenLayers': ELK_LAYER_SPACING.toString(),
  'elk.layered.spacing.nodeNode': ELK_NODE_SPACING.toString(),
  'elk.layered.spacing.edgeNodeBetweenLayers':
    ENHANCED_EDGE_NODE_SPACING.toString(), // Increased from 0 to prevent edge-node overlap
  'elk.layered.spacing.edgeEdgeBetweenLayers': ELK_EDGE_EDGE_SPACING.toString(),
  'elk.layered.spacing.inLayerSpacingFactor':
    ELK_IN_LAYER_SPACING_FACTOR.toString(),

  // Edge routing - use polyline routing for cleaner, less overlapping edges
  'elk.edgeRouting': 'POLYLINE',

  // Crossing minimization - use deterministic strategies for consistent results
  'elk.layered.crossingMinimization.strategy': 'LAYER_SWEEP',
  'elk.layered.crossingMinimization.greedySwitch.type': 'TWO_SIDED',
  'elk.layered.crossingMinimization.greedySwitchHierarchical.type': 'TWO_SIDED',

  // Cycle breaking - use deterministic greedy strategy
  'elk.layered.cycleBreaking.strategy': 'GREEDY',

  // Layering strategy - use deterministic network simplex
  'elk.layered.layering.strategy': 'NETWORK_SIMPLEX',

  // Node placement - optimize for minimal edge length and crossings
  'elk.layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
  'elk.layered.nodePlacement.bk.fixedAlignment': 'BALANCED',
  'elk.layered.nodePlacement.favorStraightEdges': 'true',
  'elk.layered.nodePlacement.networkSimplex.nodeFlexibility': 'NODE_SIZE',

  // Model order consideration - respect both node and edge order for predictable layouts
  'elk.layered.considerModelOrder.strategy': 'NODES_AND_EDGES',
  'elk.layered.considerModelOrder.portModelOrder': 'true',
  'elk.layered.considerModelOrder.crossingCounterNodeInfluence': '0.2',
  'elk.layered.considerModelOrder.crossingCounterPortInfluence': '0.5',
};

// Marriage group node handles top
export const PARENTS_SPOUSE_1_EX_HANDLE_ID = 'parents-spouse1-ex';
export const PARENTS_SPOUSE_1_HANDLE_ID = 'parents-spouse1';
export const PARENTS_SPOUSE_2_HANDLE_ID = 'parents-spouse2';
export const PARENTS_SPOUSE_2_EX_HANDLE_ID = 'parents-spouse2-ex';

// Marriage group node handles bottom
export const CHILDREN_SPOUSE_1_EX_HANDLE_ID = 'children-spouse1-ex';
export const CHILDREN_SPOUSE_1_HANDLE_ID = 'children-spouse1';
export const CHILDREN_COUPLE_HANDLE_ID = 'children-couple';
export const CHILDREN_SPOUSE_2_HANDLE_ID = 'children-spouse2';
export const CHILDREN_SPOUSE_2_EX_HANDLE_ID = 'children-spouse2-ex';

// Special handle for single ex-spouse with co-children (uses T-connector)
export const CHILDREN_SPOUSE_1_EX_COPARENT_HANDLE_ID =
  'children-spouse1-ex-coparent';
export const CHILDREN_SPOUSE_2_EX_COPARENT_HANDLE_ID =
  'children-spouse2-ex-coparent';

export const PERSON_TOP_HANDLE_ID = 'person-top';
export const PERSON_BOTTOM_HANDLE_ID = 'person-bottom';

export const MARRIAGE_GROUP_PREFIX = 'marriage-group-';
